import { useTranslations } from '@vocab/react';
import { Box, TextLinkButton, IconFlag, Text } from 'braid-design-system';

import { FormDrawer } from 'src/components/FormDrawer/FormDrawer';
import { REPORT_PROFILE } from 'src/components/Router';
import { useNavigateRoute } from 'src/components/Router/useNavigateRoute';
import { useShareableProfileSlug } from 'src/components/Router/useShareableProfileSlug';
import { EDIT } from 'src/consts';
import { REPORT_PROFILE_FORM } from 'src/context/FormContext';

import translations from './.vocab';
import { ReportProfileForm } from './ReportProfileForm';

export const ReportProfile = () => {
  const { t } = useTranslations(translations);
  const navigate = useNavigateRoute();
  const profileSlug = useShareableProfileSlug();

  const onClickHandler = () => {
    navigate({
      card: REPORT_PROFILE,
      mode: EDIT,
      name: profileSlug,
    });
  };

  return (
    <Box>
      <Box paddingTop="medium">
        <Text
          size="small"
          align={{ mobile: 'center', tablet: 'right' }}
          tone="secondary"
        >
          <TextLinkButton
            icon={<IconFlag />}
            onClick={onClickHandler}
            hitArea="large"
            weight="weak"
            data={{ automation: 'report-profile-button' }}
          >
            {t('Report this profile')}
          </TextLinkButton>
        </Text>
      </Box>
      <FormDrawer
        title={t('Report this profile')}
        component={ReportProfileForm}
        card={REPORT_PROFILE}
        formName={REPORT_PROFILE_FORM}
      />
    </Box>
  );
};
